var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0556 25L14.3056 16.25C13.6111 16.8056 12.8125 17.2454 11.9097 17.5694C11.0069 17.8935 10.0463 18.0556 9.02778 18.0556C6.50463 18.0556 4.36944 17.1815 2.62222 15.4333C0.875 13.6852 0.000925926 11.55 0 9.02778C0 6.50463 0.874074 4.36944 2.62222 2.62222C4.37037 0.875 6.50556 0.000925926 9.02778 0C11.5509 0 13.6866 0.874074 15.4347 2.62222C17.1829 4.37037 18.0565 6.50556 18.0556 9.02778C18.0556 10.0463 17.8935 11.0069 17.5694 11.9097C17.2454 12.8125 16.8056 13.6111 16.25 14.3056L25 23.0556L23.0556 25ZM9.02778 15.2778C10.7639 15.2778 12.2398 14.6704 13.4556 13.4556C14.6713 12.2407 15.2787 10.7648 15.2778 9.02778C15.2778 7.29167 14.6704 5.8162 13.4556 4.60139C12.2407 3.38657 10.7648 2.7787 9.02778 2.77778C7.29167 2.77778 5.8162 3.38565 4.60139 4.60139C3.38657 5.81713 2.7787 7.29259 2.77778 9.02778C2.77778 10.7639 3.38565 12.2398 4.60139 13.4556C5.81713 14.6713 7.29259 15.2787 9.02778 15.2778Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c939085917b40716e578c0b9982cad3e.svg";
export { ForwardRef as ReactComponent };